import $ from 'jquery';

const selected_filters = [];

const loadPosts = ( selector, paged, categories ) => {

    const parent = selector.closest( '.js-wrap-loop-posts' );
    const loop   = parent.find( '.js-loop-posts' );

    parent.addClass( 'loading' );

    const data = {
        action: 'work_filter',
        paged: paged,
        categories: JSON.stringify( categories ),
    };

    $.post( themeVars['ajax_url'], data, function( response ) {
        loop.empty();
        loop.append( response );

        parent.removeClass( 'loading' );
    });
}

$( document ).on('click', '.js-filter-item', function(e) {
    e.preventDefault();

    const $this    = $(this);
    const category = $this.data( 'category' );
    const index    = selected_filters.indexOf( category );

    if ( index > -1 ) {
        selected_filters.splice( index, 1 );
    } else {
        selected_filters.push( category );
    }
    
    $this.toggleClass( 'selected' );
    
    loadPosts( $this, 1, selected_filters );
});



$( document ).on('click', '.js-wrap-loop-posts .pagination a', function(e) {
    e.preventDefault();

    const $this = $(this);
    const paged = $this.data( 'page' );
    
    loadPosts( $this, paged, selected_filters );
});